import "./listbox.css";
import s from "react";
import { ListBox as o } from "react-aria-components";
import { g as r } from "./elements.utils-DGLsBlHK.mjs";
const a = "_list_lzcv0_1", i = {
  list: a
}, n = s.forwardRef(
  ({ ...t }, e) => (t.className = r(t, i.list), /* @__PURE__ */ s.createElement(o, { ...t, ref: e }))
);
export {
  n as R
};
